<template>
  <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Vos produits</h4>
          <p class="category">Liste des produits que vous avez ajouté</p>
          <br />
        </div>
        <div class="card-content">
          <div class="table-responsive">
            <el-table class="table-shopping"
                      style="width: 100%"
                      :data="products">
              <el-table-column min-width="120">
                <template slot-scope="props">
                  <div class="img-container">
                     <ImageLoader style="cursor: pointer;" @click="$refs.input.click()" :picture="props.row.picture" default="static/img/default-product.png" :reference="`/companies/${company.id}/products/${props.row.id}`" />
                   </div>
                </template>
              </el-table-column>
              <el-table-column min-width="220">
                <template slot-scope="props">
                  <strong>{{props.row.name}}</strong>
                  <p>{{props.row.description}}</p>
                </template>
              </el-table-column>
              <el-table-column
                min-width="180"
                class="td-category"
                label="Catégorie">
                <template slot-scope="props">
                  {{props.row.category}}
                </template>
              </el-table-column>
              <el-table-column
                min-width="150"
                label="Inventaire"
                class="td-number td-quantity">
                <template slot-scope="props">
                  {{props.row.quantity}}
                  <div class="btn-group">
                    <button class="btn btn-sm" @click="props.row.quantity > 0 ? props.row.quantity-- : 0"><i class="ti-minus"></i></button>
                    <button class="btn btn-sm" @click="props.row.quantity++"><i class="ti-plus"></i></button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                min-width="80"
                class="td-price"
                label="Prix">
                <template slot-scope="props">
                  <strong><small>&euro;</small> {{ props.row.price}} </strong>
                </template>
              </el-table-column>
              <el-table-column label="Total"  min-width="100">
                <template slot-scope="props">
                  <strong><small>&euro;</small> {{ props.row.price}} </strong>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="card-footer">
          <button @click="$router.push({name: 'ProductAdd'})" class="btn btn-default btn-fill btn-wd btn-back">Ajouter</button>
        </div>
      </div>
    </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import { mapGetters, mapActions } from 'vuex'
  import ImageLoader from '@/components/Utils/Image'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination,
      ImageLoader
    },
    computed: {
      ...mapGetters('companies', {
        company: 'mine'
      }),
      ...mapGetters('products', {
        products: 'all'
      }),
      pagedData () {
        return this.products.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.products.total = this.products.length
          return this.pagedData
        }
        let result = this.products
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['name', 'email', 'age'],
        tableColumns: [
          {
            prop: 'name',
            label: 'Name',
            minWidth: 200
          },
          {
            prop: 'email',
            label: 'Email',
            minWidth: 250
          },
          {
            prop: 'age',
            label: 'Age',
            minWidth: 100
          },
          {
            prop: 'salary',
            label: 'Salary',
            minWidth: 120
          }
        ]
      }
    },
    created () {
      this.getAllProducts(this.company)
    },
    watch: {
      company (company) {
        this.getAllProducts(company)
      }
    },
    methods: {
      ...mapActions('products', {
        getAllProducts: 'bind'
      }),
      handleLike (index, row) {
        alert(`Your want to like ${row.name}`)
      },
      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },
      error (el) {
        console.log(el)
      },
      handleDelete (index, row) {
        let indexToDelete = this.products.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          this.products.splice(indexToDelete, 1)
        }
      },
      getSummaries (param) {
        const { columns } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = 'Total'
          } else if (index < columns.length - 1) {
            sums[index] = ''
          } else {
            let sum = 0
            this.products.forEach((obj) => {
              sum += obj.quantity * obj.price
            })
            sums[index] = `€ ${sum}`
          }
        })
        return sums
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Company/Product/List.vue